import { FunctionalCharacteristicType } from './functional-characteristic-type';

export class FunctionalAnalysesArea {
  functionalAnalysisAreaId: number;
  name: string;
  functionalCharacteristicType: FunctionalCharacteristicType;
}
